import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.04761 10.9524C9.97142 12.2543 11.9152 12.0257 12.8676 10.9524L14.7619 9.0476C15.8324 7.87808 15.8705 6.3676 14.7619 5.23808C13.68 4.13618 12.0343 4.13618 10.9524 5.23808L9.04761 7.14284"
          stroke="black"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9524 10.0666C10.0286 8.76474 8.09525 8.92665 7.14287 9.99998L5.2381 11.8809C4.16763 13.0505 4.12953 14.5847 5.2381 15.7143C6.32001 16.8162 7.96572 16.8162 9.04763 15.7143L10.9524 13.8095"
          stroke="black"
          strokeWidth="1.15"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
